import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, User } from 'lucide-react';
import { useSiteData } from '../lib/SiteDataContext';
import { resolveImage } from '../lib/api';

const NewsSection = () => {
  const { news, settings } = useSiteData();
  const hs = settings?.home_sections || {};
  const items = (news || []).slice().sort((a, b) => a.order - b.order).slice(0, 3);
  if (items.length === 0) return null;
  return (
    <section className="bg-white py-24">
      <div className="mx-auto max-w-[1280px] px-6">
        <div className="mb-12 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <div className="mb-3 text-[12px] font-semibold uppercase tracking-[0.22em] text-[#C9A86A]">
              {hs.news_eyebrow || 'Latest Updates'}
            </div>
            <h2 className="font-serif text-3xl font-bold leading-tight text-[#0B2545] md:text-[40px]">
              {hs.news_title || 'News & Announcements'}
            </h2>
            <div className="mt-5 h-[3px] w-16 bg-[#C9A86A]" />
          </div>
          <Link to="/news" className="group inline-flex items-center gap-2 rounded-md bg-[#0B2545] px-5 py-3 text-[14px] font-medium text-white transition hover:bg-[#08203a]">
            {hs.news_button_label || 'View All News'}
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((n) => (
            <Link
              key={n.id}
              to={`/news/${n.id}`}
              className="group overflow-hidden rounded-lg border border-[#E6DDC8] bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="relative h-[220px] w-full overflow-hidden bg-[#F6F2EA]">
                {n.image_url && (
                  <img src={resolveImage(n.image_url)} alt={n.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                )}
                <div className="absolute left-4 top-4 inline-flex items-center gap-2 rounded-full bg-white/95 px-3 py-1 text-[11.5px] font-medium text-[#0B2545] shadow">
                  <Calendar size={12} className="text-[#C9A86A]" />
                  {n.date}
                  <span className="mx-1 h-3 w-px bg-[#0B2545]/20" />
                  <span className="uppercase tracking-wide text-[#C9A86A]">{n.category}</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-serif text-[18px] font-semibold leading-snug text-[#0B2545] transition-colors group-hover:text-[#C9A86A]">{n.title}</h3>
                <p className="mt-3 line-clamp-3 text-[14px] leading-relaxed text-[#0B2545]/70">{n.excerpt}</p>
                <div className="mt-5 flex items-center gap-2 border-t border-[#E6DDC8] pt-4 text-[12.5px] text-[#0B2545]/60">
                  <User size={13} className="text-[#C9A86A]" />
                  {n.author}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
